module.exports = __webpack_public_path__ + "static/img/logo.04ca2a30.svg";